/**
 * ============================================================================
 * SportPreferencesChart - Sport Preferences Progress Bars
 * ============================================================================
 */

import React from 'react';
import type { SportPreference } from '../../types/customerInsights';

interface SportPreferencesChartProps {
  data: SportPreference[];
}

export function SportPreferencesChart({ data }: SportPreferencesChartProps) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6">
      <h3 className="text-xl font-semibold text-gray-900 mb-6">Sport Preferences</h3>
      <div className="space-y-4">
        {data && data.length > 0 ? (
          data.map((sport, idx) => (
            <div key={idx}>
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center space-x-3">
                  <span className="font-semibold text-gray-900">{sport.sport}</span>
                  <span className="text-sm text-gray-600">
                    ({sport.customers} customers)
                  </span>
                </div>
                <span className="font-semibold text-gray-900">{sport.percentage}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-blue-500 h-2 rounded-full transition-all"
                  style={{ width: `${sport.percentage}%` }}
                ></div>
              </div>
            </div>
          ))
        ) : (
          <p className="text-gray-500 text-center py-8">No sport data available</p>
        )}
      </div>
    </div>
  );
}
